import { render } from "./fieldRadio.vue?vue&type=template&id=42f2a01e&scoped=true"
import script from "./fieldRadio.vue?vue&type=script&lang=js"
export * from "./fieldRadio.vue?vue&type=script&lang=js"

import "./fieldRadio.vue?vue&type=style&index=0&id=42f2a01e&scoped=true&lang=scss"

import exportComponent from "/builds/oleksandr.makhovskyi/admin-template/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42f2a01e"]])

export default __exports__